import { avatarAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(avatarAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    bg: 'gray.100',
    color: 'black',
    fontWeight: '600',
    position: 'auto'
  },
  excessLabel: {
    bgColor: 'black',
    border: '1px solid',
    borderColor: 'white',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
    color: 'white',
    fontSize: '10px',
    fontWeight: '500'
  }
});

const xs = definePartsStyle({
  container: {
    position: 'auto',
    width: '22px',
    height: '22px'
  },
  excessLabel: {
    fontSize: 'calc(1.5rem / 2.5)'
  }
});

const bgWhite = definePartsStyle({
  excessLabel: {
    bgColor: 'white',
    color: 'black',
    fontSize: '10px',
    fontWeight: '500',
  },
});

export const Avatar = defineMultiStyleConfig({
  baseStyle,
  sizes: {
    xs
  },
  variants: {
    bgWhite
  }
});